import React from "react";
import "./styling/HeaderFooter.css";

const Footer = () => (
  <footer className="main-footer">
    <div className="footer-content">
      <span className="footer-divider">|</span>
      <span>Contact: asetcgorakhpur@gmail.com | +91-9005338310</span>
      <span className="footer-divider">|</span>
      <span>Powered by: harshpratapmall@gmail.com</span>
    </div>
  </footer>
);

export default Footer;
